<template>
  <v-container class="ma-0 pa-0">
    <h1>{{$t('labels.completed-title')}}</h1>
    <p>{{ $t('labels.completed-text') }}</p>
    <p class="tight">
      <span class="big-label">{{ $t('labels.name') }}</span>
      <br />
      {{ fullname }}
    </p>
    <p class="tight">
      <span class="big-label">{{ $t('labels.email2') }}</span>
      <br />
      {{ email }}
    </p>
    <p class="tight">
      <span class="big-label">{{ $t('labels.mobile') }}</span>
      <br />
      {{ mobilephone | phoneNo }}
    </p>

    <p>
      <strong>{{ $t('labels.completed-text2') }}</strong>
    </p>

    <NextButton
      class="mt-3"
      @enter="nextStep"
      :isEnterSubmit="true"
      @click="nextStep"
      :isDisabled="isImitatingUser()"
    >{{$t('labels.to-myPage')}}</NextButton>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import pick from 'lodash/pick'
import NextButton from '@/components/Common/NextButton'

// @group Registration
// Styled MobileEmailDone component
export default {
  name: 'MobileEmailDone',

  components: {NextButton},

  data() {
    return {
      fullname: ''
    }
  },
  props: {
    //has mobilephone
    mobilephone: {
      // `'String'` /
      type: String,
      // The default value is: ` '' `
      default: ''
    },
    //has email
    email: {
      // `'String'` /
      type: String,
      // The default value is: ` '' `
      default: ''
    }
  },

  created() {
    this.init()
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isImitatingUser'])
  },

  methods: {
    init() {
      if (this.currentUser && this.currentUser.firstName && this.currentUser.lastName) {
        this.fullname = this.currentUser.firstName + ' ' + this.currentUser.lastName
      }
    },

    nextStep() {
      this.$nextTick(() => {
        this.$router.push({name: 'Start'}).catch(() => {})
      })
    }
  }
}
</script>

<style scoped>
.email {
  white-space: nowrap;
  font-weight: bold;
}
</style>